export class VSSettings {
  id?: number;

  tourId: number;

  ambientLight: number;

  pointLight: number;

  lightHeight: number;

  shadowIntensity: number;

  lightAngle: number;

  updatedAt?: string;

  constructor(model: any = {}) {
    this.id = model.id;
    this.tourId = model.tourId;
    this.ambientLight = model.ambientLight * 1.3 || 9.5;
    this.pointLight = model.pointLight * 1.3 || 33 * 3;
    this.lightHeight = model.lightHeight * 5 || 75 * 0.5;
    this.shadowIntensity = model.shadowIntensity >= 0 ? model.shadowIntensity : 0.2;
    this.lightAngle = model.lightAngle || 0;
    this.updatedAt = model.updatedAt;
  }
}
